import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isSessionExpiredModalOpen = false; // Flag to track modal state

  constructor(
    private injector: Injector,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Interceptar erros 403 para módulo Admin
        if (error.status === 403) {
          let mensagem = 'Você não tem permissão para realizar esta operação.';
          
          // Personalizar mensagens por URL específica
          if (error.url?.includes('/usuario/register')) {
            mensagem = 'Somente SuperAdministrador pode cadastrar.';
            console.log('Exibindo mensagem personalizada de 403:', mensagem);
          } 
          else if (error.url?.includes('/usuario/delete')) {
            mensagem = 'Somente SuperAdministrador pode excluir.';
          }
          else if (error.url?.includes('/usuario/update') && request.body instanceof FormData && 
                   request.body.has('role') && request.body.get('role') === 'Administrador') {
            mensagem = 'Somente SuperAdministrador pode gerenciar Administradores.';
          }
          
          Swal.fire({
            title: 'Permissão Negada',
            text: mensagem,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false // Forçar usuário a confirmar
          });
          
          // Retorna o erro com a mensagem personalizada para atualizar o estado do componente
          return throwError(() => new Error(mensagem));
        }
        
        // Check for 440 status and ensure modal isn't already open
        if (error.status === 440 && !this.isSessionExpiredModalOpen) {
          this.isSessionExpiredModalOpen = true; // Set flag immediately

          // Display the modal immediately upon catching the error and force it to be on top
          Swal.fire({
            title: 'Sessão Expirada',
            text: 'Sua conta foi acessada em outro dispositivo. Por favor, faça login novamente.',
            icon: 'warning',
            confirmButtonText: 'OK',
            allowOutsideClick: () => false, // Use function for robustness against outside click
            allowEscapeKey: false,
            allowEnterKey: false
          }).then((result) => {
            // This block executes *after* the user interacts with the modal
            this.isSessionExpiredModalOpen = false; // Reset flag
            if (result.isConfirmed) {
              // Usar o injector para obter AuthService quando necessário, evitando dependência circular
              const authService = this.injector.get('AuthService');
              if (authService && typeof authService.logout === 'function') {
                authService.logout();
              } else {
                // Fallback caso o authService não esteja disponível
                localStorage.clear();
              }
              this.router.navigate(['/pages/usuarios/autenticar']);
            }
            // Handle potential dismissals if necessary, though allowOutsideClick/allowEscapeKey should prevent most
          }).catch(() => {
             // Catch potential errors from Swal.fire itself
             this.isSessionExpiredModalOpen = false; // Ensure flag is reset even on Swal error
          });
        }
        // Important: Re-throw the error so other error handlers can process it if needed
        return throwError(() => error);
      })
    );
  }
}